<template lang="pug">
.faqs
  h2.faqs__title {{ $t('pages.ssrGiftCards.faq.title') }}
  .faqs__list
    .faqs__list-item(v-for="question in faqs")
      Question(
        @open="setOpenQuestion"
        :id="question.id"
        :title="question.title"
        :text="question.description_text"
        :is-expanded="openQuestionId === question.id"
        )
  .faqs__learn_more
    span {{ $t('pages.ssrGiftCards.faq.learn_more') }} {{' '}}
    Link(:href="learnMoreLink" target='_blank') {{ $t('pages.ssrGiftCards.faq.link').toLowerCase() }}.
</template>

<script>
import Question from './Question.vue'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    Question,
    Link
  },
  props: {
    faqs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      openQuestionId: null
    }
  },
  computed: {
    learnMoreLink () {
      return `https://help.rss.com/${this.$i18n.locale}/support/solutions/folders/44001241196`
    }
  },
  methods: {
    setOpenQuestion (questionId) {
      this.openQuestionId = this.openQuestionId !== questionId ? questionId : null
    }
  }
}
</script>

<style lang="scss" scoped>
.faqs {
  display: flex;
  flex-direction: column;
  gap: $gap * 1.5;
  padding: $gap * 2.5;
  border-radius: $gap * 0.5;
  color: #ffffff;

  @include display-less(tablet) {
    padding: $gap;
  }

  background-color: #2e1f42;
  &__title {
    font-weight: 700;
    font-size: 24px;
    color: #ffffff;
  }

  &__list-item {
    border-bottom: 1px solid #797088;
    padding-bottom: $gap;
    &:not(:last-child) {
      margin-bottom: $gap;
    }
  }
}
</style>
